import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import HeadlessInput from '../../../shared/component/headless/input/HeadlessInput';
import { MemberInfoValueMobile } from '../../../shared/component/headless/input/InputBody';
import HeadlessBtn from '../../../shared/component/headless/button/HeadlessBtn';
import { BlackFullWidthBtn } from '../../../shared/component/headless/button/BtnBody';
import { useModalStore } from '../../../shared/store/portal/modalStore';
import { getModalMessage } from '../../../shared/constants/modalMessages';
import { getBtnName } from '../../../shared/constants/btnNames';
import UniversalIconBtn from '../../../shared/component/headless/button/UniversalIconBtn';
import belowIcon from '../../../asset/icon/below.png';

interface ModalProps {
  setIsUserInput: (isUserInput: boolean) => void;
}

const ChangeUsernameModalMobile: React.FC<ModalProps> = ({ setIsUserInput }) => {
  const { standardModal, clearModal } = useModalStore();
  const [username, setUsername] = useState(standardModal?.value || "");

  useEffect(() => {
    if (username.length > 0) {
      setIsUserInput(true);
    } else {
      setIsUserInput(false);
    }
  }, [username, setIsUserInput]);

  if (standardModal == null) return null;

  const handleChangeUsername = () => {
    if (standardModal.handleChange) {
      standardModal.handleChange(username);
    }
    clearModal();
  };

  return (
    <ChangeUsernameModalComp>
      <TitleWrapper>
        <Title>{getModalMessage('CHANGE_USERNAME_TITLE')}</Title>
        <UniversalIconBtn
          size="fit"
          border={false}
          isTransparent
          backgroundImg={belowIcon}
          onClick={() => clearModal(400)}
        />
      </TitleWrapper>
      <HeadlessInput
        type={'text'}
        value={username}
        handleChange={(e) => setUsername(e.target.value.slice(0, 30))}
        placeholder={getModalMessage('ENTER_FIELD', { field: standardModal?.title ?? '' })}
        StyledInput={MemberInfoValueMobile}
      />
      <HeadlessBtn
        value={getBtnName('CHANGE')}
        handleClick={handleChangeUsername}
        StyledBtn={SubmitButton}
      />
    </ChangeUsernameModalComp>
  );
};

const ChangeUsernameModalComp = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 14px;
`

const TitleWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: ${({ theme }) => theme.colors.color_Gray_02};
  margin-top: clamp(12px, 2vh, 30px);
  margin-bottom: clamp(20px, 8vh, 30px);
`;

const Title = styled.h2`
  ${({ theme }) => theme.typography.Body_01_1};
  color: ${({ theme }) => theme.colors.color_Gray_02};
`;



const SubmitButton = styled(BlackFullWidthBtn)`
  margin: 20px 0px 15px 0px;
`;

export default ChangeUsernameModalMobile;
